import { type ResultOf, type VariablesOf, graphql } from "gql.tada";

import RestaurantFragment from "../fragments/restaurant";

const RestaurantDetailsQuery = graphql(
  `
    query RestaurantDetails($id: Int!) {
      Restaurant(id: $id) {
        ...RestaurantFragment
      }
    }
  `,
  [RestaurantFragment],
);

export type QueryVariables = VariablesOf<typeof RestaurantDetailsQuery>;
export type QueryResult = ResultOf<typeof RestaurantDetailsQuery>;

export default RestaurantDetailsQuery;
